import { Component, OnInit } from '@angular/core';
 
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { CustomServiceService } from '../../service/custom-service.service';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-immovable-property', 
  templateUrl: './immovable-property.component.html',
  styleUrls: ['./immovable-property.component.css']
})
export class ImmovablePropertyComponent implements OnInit {

  
  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private encDec: EncryptDecryptService, private route: Router,private routerparam: ActivatedRoute) { }

 
  language = sessionStorage.getItem('locale');//dynamic

  ngOnInit(): void {
    this.getDivision();
    this.start=(this.currentPage - 1)*this.limit;
    setTimeout(()=>{
      this.getimmovablepropertyList('','','','',this.start,this.limit,this.currentPage);
    },1000)  
    
    this.getYear();
    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if(this.employee_con==null){
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
  }

  navmenuloadCss = "background-color: #167a44; height: 100%;";
  p_apirespons: any;
  P_data: any
  plugin_menu_dtl:any;
  employee_con:any="";
  showEmpMen:boolean=false;
  showNavComponent:boolean=false;
  showBarComponent:boolean=false;
  navMenu:boolean=false;
  emp_apires:any;
  emp_dtl:any={'title':''};
  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }


  backend_url: any = environment.serviceURL;
  content_apiresponse:any;
  immvResponse:any[]=[];
  immovablepropertyList:any;
  immovablepropertyLength:any;
  start:number=0;
  limit:number=10;
  ifdisabled:any;
  btncontent:any=this.language=='English'?`Search`:`खोजें`;
  currentPage:number = 1;
  totalRecords:number=0;
  issearch:any;
  isdisplay:boolean =false;

  searchForm = new FormGroup({
    design: new FormControl(''),
    cadre: new FormControl(''),
    name: new FormControl(''),
    year:new FormControl(''),
  })

  get design() {
    return this.searchForm.get('design');
  }
  get cadre() {
    return this.searchForm.get('cadre');
  }
  get name() {
    return this.searchForm.get('name');
  }
  get year() {
    return this.searchForm.get('year');
  }
 
  getimmovablepropertyList(design:any,cadre:any,name:any,year:any,start:number,limit:number,currentPage:number){
    var query:any=[];
    query = [{ "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
              { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
    ]; 
  
    if(design!==""){
      query.push({ "columnName": "VCHDESIGNATION", "operator": "LIKE", "value": `%${design}%`, "joinoperator": "and" });
    }
    if(cadre!==""){
      query.push({ "columnName": "INTCIRCULARDIV", "operator": "=", "value": cadre, "joinoperator": "and" });
    }

    if(name!==""){
      query.push({ "columnName": "VCHNAME", "operator": "LIKE", "value": `%${name}%`, "joinoperator": "and" });
    }
    if(year!==""){
      query.push({ "columnName": "VYEARCH", "operator": "LIKE", "value": `%${year}%`, "joinoperator": "and" });
    }
    if(environment.ZONE_ID > 0){
      query.push({ "columnName": "ZONE_ID", "operator": "=", "value": environment.ZONE_ID, "joinoperator": "and" });
     }
    let params = [{
      "secSlNo": 1,
      "offSet": start,
      "noOfRecords": limit,
      "orderBy": [{ "columnName": "intId", "type": "DESC" }], 
      "condition":query,
      "viewParameters": ""
    }];

    this.fciwebservice.getimmovableproperty(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.immvResponse = response.result.sec_1;
            //console.log(this.immvResponse);
            this.immovablepropertyList = this.immvResponse; 
            this.immovablepropertyLength=  this.immovablepropertyList.length ;

            if(response.result.sec_1.length > 0){
              this.totalRecords = response.result.sec_1[0].noOfRec;
              this.issearch = true;
              
            } else {
              this.totalRecords = 0;
              this.issearch = false;
            }
            this.ifdisabled = false;
            this.btncontent =this.language=='English'?`Search`:`खोजें`;
          }
      }
    });
  }


  circularDiv:any;
   getDivision(){

  let params = [{
    "secSlNo": 1,
    "offSet": 0,
    "noOfRecords": '',
    "orderBy": [{ "columnName": "intId", "type": "DESC" }],
    "condition": [
      { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
      { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" }
    ],
    "viewParameters": ""
  }];
  this.fciwebservice.getCircularDivision(params).subscribe((response: HttpEvent<any>)=>{
    switch (response.type) {
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.content_apiresponse = response.body;

        this.content_apiresponse = response.body;
        let respData = this.content_apiresponse.RESPONSE_DATA;
        let respToken = this.content_apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          this.circularDiv = response.result.sec_1;
        
        } 
    }

  });
}

getYearList:any;
getYear(){

  let params = [{
    "secSlNo": 1,
    "offSet": 0,
    "noOfRecords": '',
    "orderBy": '[{"columnName":"YEAR_","type":"DESC"}]',
    "condition": '',
    "viewParameters": ""
  }];
  this.fciwebservice.getYear(params).subscribe((response: HttpEvent<any>)=>{
    switch (response.type) {
      case HttpEventType.Sent:
        //console.log('Sent' + HttpEventType.Sent);
        break;
      case HttpEventType.ResponseHeader:
        //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
        break;
      case HttpEventType.UploadProgress:
        //this.evenTotal = response.total;
        //this.progress = Math.round(response.loaded / this.evenTotal * 100);
        break;
      case HttpEventType.Response:
        this.content_apiresponse = response.body;

        this.content_apiresponse = response.body;
        let respData = this.content_apiresponse.RESPONSE_DATA;
        let respToken = this.content_apiresponse.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response);
          this.getYearList = response.result;
        
        
        } 
    }

  });
}


searchImmovablepropertylList(){
  let param_arr = []; 
  this.isdisplay = true;
  let design,cadre,name,year;
  design="";
  cadre="";
  name="";
  
  year="";
  if(this.searchForm.value.design!==""){
    if(this.searchForm.value.design!==null){
      param_arr.push(this.searchForm.value.design);
      design = this.searchForm.value.design;
    }
  }
  if(this.searchForm.value.cadre!==""){
    if(this.searchForm.value.cadre!==null){
      param_arr.push(this.searchForm.value.cadre);
      cadre = this.searchForm.value.cadre;

      
    }
  }

  if(this.searchForm.value.name!==""){
    if(this.searchForm.value.name!==null){
      param_arr.push(this.searchForm.value.name);
      name = this.searchForm.value.name;
    }
  }
  if(this.searchForm.value.year!==""){
    if(this.searchForm.value.year!==null){
      param_arr.push(this.searchForm.value.year);
      year = this.searchForm.value.year;
    }
  }
  
  if(param_arr.length <= 0){
   
    Swal.fire({
      icon: 'warning',
      text: (this.language=='English') ? "Please select at least one parameter" : "कृपया कम से कम एक पैरामीटर चुनें",
    });
    return;
  }
   this.RefreshBtn=true;
  this.start=0;
  this.limit=10;
  this.currentPage = 1;
  this.totalRecords = 0;
  this.getimmovablepropertyList(design,cadre,name,year,this.start,this.limit,this.currentPage);
  
}

RefreshBtn:boolean=false;
RefreshPage(){
  this.start=0;
  this.limit=10;
  this.currentPage = 1;
  this.totalRecords = 0;
  this.getimmovablepropertyList('','','','',this.start,this.limit,this.currentPage);
  this.RefreshBtn = false;
  this.searchForm.reset();
 
}
  getDivisionName(data: any):any {
    let n:any='';
  this.circularDiv.forEach((element:any) => {
    if(element.id==data.selectCadres){
      n = (this.language=='English') ?element.name:element.nameInHindi;
    }
  });
  return n;

    // const jsonOptTxtDetails = JSON.parse(data.jsonOptTxtDetails);
    // return jsonOptTxtDetails.INTCIRCULARDIV;

    

  }
  checkFileExists(obj:any):boolean{
    if(obj.iPRDocument==""){
      return false;
    }
    if(obj.iPRDocument_details==undefined){
      return false;
     }
    if(obj.iPRDocument_details.fileSize==undefined){
      return false;
     }
   if(obj.iPRDocument_details.fileSize==""){
    return false;
   }
  return true;
  }
  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }
  pageChanged(page: any) {
    this.currentPage=page
    this.start=(this.currentPage - 1)*this.limit;
    this.getimmovablepropertyList('','','','',this.start,this.limit,this.currentPage);
  }







  checkFileType(data:any):any{
    let ext:any,fileType:any;
    ext= ['webp','jpeg', 'jpe', 'png', 'gif', 'jpg', 'pdf', 'PNG','xlsx','xls','csv','docx','doc'];
    if(data==""){
      return false; 
    }
    if(data.iPRDocument==""){
      return false; 
    }
    if(data.iPRDocument_details==undefined){
      return false; 
    }
    if(data.iPRDocument_details.fileType==undefined){
      return false; 
    }
    if(data.iPRDocument_details.fileType==''){
      return false; 
    }
    fileType=data.iPRDocument_details.fileType.toLowerCase();
    if(fileType=='xlsx' || fileType=='xls' || fileType=='csv'){
      return {'fileType':fileType,'file': ` <i class="fa fa-file-excel-o" aria-hidden="true"></i> ${fileType} ||`}; 
    } else if(fileType=='docx' || fileType=='doc'){
      return {'fileType':fileType,'file':` <i class="fa fa-file-word-o" aria-hidden="true"></i> ${fileType} ||`}; 
    } else if(fileType=='pdf'){
      return {'fileType':fileType,'file':` <i class="fa fa-file-pdf-o" aria-hidden="true"></i> ${fileType} ||`}; 
    } else {
      return {'fileType':fileType,'file':` <i class="fa fa-file-text" aria-hidden="true"></i> ${fileType} ||`}; 
    }
  
  }




  getEmployeeCornerDtl(id:any){
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [ 
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break; 
        case HttpEventType.Response:
        this.emp_apires = response.body;
        let respData = this.emp_apires.RESPONSE_DATA;
        let respToken = this.emp_apires.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.result.sec_1.length > 0){
            this.emp_dtl=response_.result.sec_1[0];
            this.showBarComponent=true;
            this.showEmpMen = true;
          }
        } 
      }
    });
  }


  getPluginPageDetials(details:any) {
    let params;
    if(details!==null){
      let d = JSON.parse(details);
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link':d.selectPlugin,
        'localdata':true,
      };
    } else{
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link':this.CurrentRouteFn(),
        'localdata':false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
        this.p_apirespons = response.body;
        let respData = this.p_apirespons.RESPONSE_DATA;
        let respToken = this.p_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          // console.log(response_.original);
          if(response_.original.status){
            this.P_data = response_.original;
            this.navMenu = response_.original.hasMenu;
            this.navmenuloadCss = "height: 100%;";
          } else {
            this.P_data = response_.original;//somthing wrong
          }
          this.showNavComponent=true;
          this.showBarComponent=true;
        } 
      }
    });
  }







}
